export default __webpack_public_path__ + "static/media/number1.7c74b82e.png";